import React from 'react';

import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import dashboardAPICall from '../../app/apiCalls/dashboardAPICall'
import { cpc_dashboard_data } from "../../app/apiEndpoints"
import DataTable from "../../containers/DataTable";
import CardHeader from '../../containers/CardHeader'
import { Breadcrumb, Card } from 'react-bootstrap'
import { tableTypes } from "../../app/settings";
import DashboardOptions from "../Dashboard/DashboardOptions";
import InvalidPermissions from '../../containers/InvalidPermissions'

import Moment from 'moment';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const CPCDashboardView = (props) => {
    let query = useQuery();

    const [dashData, setDashData] = useState([])
    const [totals, setTotals] = useState({})
    let { subpid } = useParams();
    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const companyName = useSelector((state) => state.user.company.name)
    const startDate = query.get("startDate")
    const endDate = query.get("endDate") 
    const [dataLoaded, setDataLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)

    useEffect(() => {
        const getDetails = async () => {
            if(subpid.length > 0) {
                const data = await dashboardAPICall(cpc_dashboard_data, 
                    {'subpid': subpid, 
                        'requester': userID, 
                        'company': companyID, 
                        'startDate': startDate || (Moment().format('MM/DD/YYYY')), 
                        'endDate': endDate || (Moment().format('MM/DD/YYYY'))
                    })
                //if(data.dashboard) {
                //    setDashboard(data.dashboard) 
                    if(data.data) {
                        setDashData(data.data)
                        if(data.totals) {
                            setTotals(data.totals)
                        }
                    }
                //}
                else if(data.error) {
                    setHasError(true)
                }
                setDataLoaded(true)
            }
        }
        if(!dataLoaded)
            getDetails()
    }, [subpid, userID, companyID, startDate, endDate, dataLoaded])

    const tableFields = () => {
        if(dashData.length === 0) return []
        const row = dashData[0]
        const fields = Object.keys(row).map(field => field.replace(/_/g, ' '));
        return fields
    }

    const tableData = () => {
        if(dashData.length === 0) return []
        const dataRows = []
        dashData.forEach((row, i) => {
            const values = []
            Object.keys(row).forEach((field) => values.push(row[field]))
            dataRows.push({'id': i, 'values': values});
        });
        return dataRows
    }

    const csvData = () => {
        if(dashData.length === 0) return []
        const dataRows = []
        dataRows.push(tableFields())
        dashData.forEach((row, i) => {
            const values = []
            Object.keys(row).forEach((field) => values.push(row[field]))
            dataRows.push(values);
        });
        return dataRows
    }

    const csvFileName = () => {
        if(subpid.length === 0) return "Dashboard.csv"
        return `${(companyName && companyName.length > 0 ? companyName.replaceAll(" ", "_") : "")}_${subpid.replaceAll(" ", "_")}.csv`

    }
    
    if(hasError) 
        return <InvalidPermissions />

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/">Dashboards</Breadcrumb.Item>
          <Breadcrumb.Item active>{subpid} &gt; {companyName}</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
            <CardHeader title={subpid} description={companyName} />
            <Card.Body>
        <DashboardOptions 
            dashID="test"
            startDate={startDate || (Moment().add(-30, 'days').format('MM/DD/YYYY'))}
            endDate={endDate || (Moment().format('MM/DD/YYYY'))}
            formAction={`/cpc/${subpid}`} 
            csvData={csvData()}
            csvFileName={csvFileName()} />
            </Card.Body>
            {dashData?.length > 0 ?
            <>
            <DataTable 
                tableID={subpid} 
                fieldNames={tableFields()} 
                dataRows={tableData()} 
                tableSettings={tableTypes.None} 
                totals={totals}
                />
            </>
            : 
            <Card.Body>
                <Card.Text>No data was found for this time period</Card.Text>
                </Card.Body>
            }
            {!dataLoaded ? <Card.Body>Loading dashboard...</Card.Body> : <></>}
        </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(CPCDashboardView), "Dashboard View"));
